<template>
  <PageBanner
    :class="{ 'page-banner--article': article, 'page-banner--archive': archive }"
    :image="require('@/assets/images/Newlandindpage/banner/blog.webp')"
    :light-image="require('@/assets/images/Newlandindpage/banner/blog-light.png')"
    :title="title || $t('Blog.breadcrumb_title')"
    :lead="lead"
    :current="currentLabel"
    :parent-to="article || archive ? '/Blog' : ''"
    :parent-label="$t('header.blog')"
  />
</template>

<script>
import PageBanner from '../common/PageBanner'

export default {
  name: 'BlogBanner',
  components: { PageBanner },
  computed: {
    currentLabel() {
      if (this.breadcrumb) return this.breadcrumb
      if (this.article) return this.$t('Blog.article')
      return this.title || this.$t('header.blog')
    }
  },
  props: {
    archive: {
      type: Boolean,
      default: false
    },
    breadcrumb: {
      type: String,
      default: ''
    },
    article: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    lead: {
      type: String,
      default: ''
    }
  }
}
</script>
